/* Shared enum → human label helper.
 *
 * Officer surfaces must never show raw snake_case enum values
 * (`legal_person`, `partnership_interest`). Both the chain-review cards and
 * the manual-entry dropdowns route their enum display through this, so the
 * two stay consistent (the review pane used to print raw values while
 * /v2/manual humanized them — officer-sim finding #8, 2026-06-23).
 *
 * Only snake_case-shaped tokens (all-lowercase words joined by underscores)
 * are rewritten; proper names, already-spaced text, ids and mixed-case
 * values pass through untouched so we never mangle "Olmi Master Fund W".
 */
const ENUM_TOKEN = /^[a-z0-9]+(?:_[a-z0-9]+)+$/

export function humanizeEnum(value: string): string {
  return ENUM_TOKEN.test(value) ? value.replace(/_/g, ' ') : value
}
